module.exports = __webpack_public_path__ + "static/media/35.2cd9cbae.jpg";